import styled from 'styled-components';

import { ContainerOT } from '../MainStyledComponents';
import { ButtonIconBackground } from '../../../inputs/buttons/ButtonIconBackground';

export const ContainerOTStyled = styled(ContainerOT)`
  background-color: ${({ theme }) => theme.colors.softDarkWhite};
`;

export const ButtonViewDetail = styled(ButtonIconBackground)``;
